import dayjs from "web/dayjs_config";
import {
  addTranslationData,
  useTranslation,
} from "@mywheels/common/lib/translation";

import { InfoIcon } from "web/ui/icons/InfoIcon";

addTranslationData({
  en: {
    "Deze actie is over sinds 1 oktober": "This action ended on October 1st",
  },
});

export function CampaignEndedBanner() {
  const { t } = useTranslation();

  if (dayjs().isBefore("2021-10-01 00:00")) {
    return null;
  }

  return (
    <div className="bg-blue700">
      <div className="container py-4 text-white text-center font-display text-lg">
        <InfoIcon className="nudge-up mr-1" />{" "}
        {t("Deze actie is over sinds 1 oktober")}
      </div>
    </div>
  );
}
